import mobilidade_sustentavel from "../../../mockups/paineis/Frame 77_transparente.png"

export default function MobilidadeSustentavel({ getImagem }) {
  return (
    <div className="flex justify-center px-16 py-10">
      {/* <div className="border border-grayLight rounded-3xl overflow-hidden min-h-[450px] flex flex-col">
        <header className="bg-blue text-white py-6 text-center">
          <h1 className="text-4xl font-bold">Mobilidade sustentável</h1>
        </header>

        <div className="flex-1 flex items-center justify-center p-10">
          <div className="grid grid-cols-2 gap-14 w-full">
            ITEM 1
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-6">
                <img src={getImagem(11)} className="h-[130px]" alt="" />

                <div>
                  <h1 className="text-5xl font-bold text-deepBlue">1.259</h1>
                  <p className="text-3xl font-semibold text-deepBlue">
                    ônibus movidos
                    <br />a energia limpa
                  </p>
                </div>
              </div>

              <p className="text-3xl text-greenDark mt-4">
                1 ônibus elétrico = 6.464 árvores
              </p>
            </div>

            ITEM 2 
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-6">
                <img
                  src={getImagem(12)}
                  className="h-[130px]"
                  alt="Imagem de um caminhão de coleta"
                />

                <div>
                  <h1 className="text-5xl font-bold text-deepBlue">+250</h1>
                  <p className="text-3xl font-semibold text-deepBlue">
                    caminhões e carretas
                    <br />
                    de coleta de resíduos
                  </p>
                </div>
              </div>

              <p className="text-3xl text-greenDark mt-4">
                1 caminhão a biometano = 6.100 árvores
              </p>
            </div>
          </div>
        </div>
      </div> */}

      <img src={mobilidade_sustentavel} alt="" />
    </div>
  );
}
